import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';
import { FOR_PROFIT_COMPANY_TYPES } from '../../../../../../../constants';

const { forProfitCompanyType } = loanFormModel.formField;

class IsForProfitCompanyTypeEqualTo implements Rule {
  private forProfitCompanyTypeValue: FOR_PROFIT_COMPANY_TYPES;

  public setCompanyType(companyTypeValue: FOR_PROFIT_COMPANY_TYPES) {
    this.forProfitCompanyTypeValue = companyTypeValue;
    return this;
  }

  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const companyType = application[
      forProfitCompanyType.name
    ] as FOR_PROFIT_COMPANY_TYPES | null;
    return companyType === this.forProfitCompanyTypeValue;
  }
}

export default new IsForProfitCompanyTypeEqualTo();
